
import { getWidgetLayout } from "../../../api/home/widgetLayout.service";
import { WIDGET_LAYOUT_CONFIG } from "../actionTypes";


const widgetLayoutRequest = ()=>({type: WIDGET_LAYOUT_CONFIG.REQUEST})
const widgetLayoutFailure = (error)=>({type: WIDGET_LAYOUT_CONFIG.FAILURE, error})
const widgetLayoutSuccess = (obj)=>({type: WIDGET_LAYOUT_CONFIG.SUCCESS, obj})

export const getWidgetLayoutConfig = ()=>{
    return (dispatch, getState)=>{        
        dispatch(widgetLayoutRequest()) 
        return getWidgetLayout()  
        .then(response => {            
            let obj={
                'data':response.data,
                // 'next':response.next,
                // "isLoadMore": next?true:false
            }    
            dispatch(widgetLayoutSuccess(obj))
            return Promise.resolve(true)
        })
        .catch(error => {
            dispatch(widgetLayoutFailure(error?.message))
            return Promise.resolve(false)
        })
    }
}